module.exports = __webpack_public_path__ + "img/slide-15.3964e562.jpg";